import * as XLSX from 'xlsx';
import { downloadCsvFile } from 'dashboard/helper/downloadHelper';

const escapeCsvCell = value => {
  if (value === null || value === undefined) return '';
  let cell = String(value);
  // guard against spreadsheet formula injection
  if (/^[=+\-@]/.test(cell)) cell = `'${cell}`;
  if (/[",\n]/.test(cell)) cell = `"${cell.replace(/"/g, '""')}"`;
  return cell;
};

export const generateCsv = rows =>
  rows.map(row => row.map(escapeCsvCell).join(',')).join('\n');

// build the sheet from raw values so text headers like "8:00" are not coerced into Excel time serials
export const downloadXlsxFromRows = (fileName, rows) => {
  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
  XLSX.writeFile(workbook, fileName);
};

export const downloadReportRows = (fileName, fileFormat, rows) => {
  if (fileFormat === 'xlsx') {
    downloadXlsxFromRows(fileName, rows);
    return;
  }
  downloadCsvFile(fileName, generateCsv(rows));
};
